import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'environments/environment';
import { catchError, map } from 'rxjs';
import { ErrorService } from '@cosmos/angular/utils';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private http = inject(HttpClient);
  private errorService = inject(ErrorService);

  // ==================== PROJECT DASHBOARD ENDPOINTS ====================

  getActiveDevicesCount(projectId: string, timeframe: string = '24h') {
    return this.http
      .get(
        `${environment.API_URL}/dashboard/project/${projectId}/active-devices?timeframe=${timeframe}`
      )
      .pipe(
        map((response) => response),
        catchError((error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  getActiveMeasurementsCount(projectId: string) {
    return this.http
      .get(
        `${environment.API_URL}/dashboard/project/${projectId}/active-measurements`
      )
      .pipe(
        map((response) => response),
        catchError((error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  getPoursCount(projectId: string, timeframe?: string) {
    const params = timeframe ? `?timeframe=${timeframe}` : '';
    return this.http
      .get(
        `${environment.API_URL}/dashboard/project/${projectId}/pours-count${params}`
      )
      .pipe(
        map((response) => response),
        catchError((error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  getActiveLotsCount(projectId: string) {
    return this.http
      .get(
        `${environment.API_URL}/dashboard/project/${projectId}/active-lots`
      )
      .pipe(
        map((response) => response),
        catchError((error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  // IMPLEMENTED IN ANALYTICS AGGREGATION SERVICE
  // getDocumentsCount(projectId: string) {
  //   return this.http
  //     .get(
  //       `${environment.API_URL}/dashboard/project/${projectId}/documents-count`
  //     )
  //     .pipe(
  //       map((response) => response),
  //       catchError((error) =>{this.errorService.handleError(error); throw error;})
  //     );
  // }
}
